window.app = window.app || {};

window.app.productTabs = {
  device: 'desktop',
  el: {
    accordions: document.querySelectorAll('.mt-product-main-tabs__item'),
    tabs: document.querySelectorAll('.mt-product-main-tabs__nav-item')
  },

  updateActiveTab() {
    const _this = window.app.productTabs;

    if ( _this.el.accordions.length === 0) return;
    if (window.innerWidth <= 767 && _this.device === 'desktop') {
      _this.el.accordions.forEach(accordion => accordion.removeAttribute('open'));
      _this.device = 'mobile';
    } else if (window.innerWidth >= 768 && _this.device === 'mobile') {
      _this.el.accordions.forEach(accordion => accordion.removeAttribute('open'));
      _this.el.tabs.forEach(tab => tab.classList.remove('active'));
      _this.el.tabs[0].classList.add('active');
      _this.el.accordions[0].setAttribute('open','');
      _this.device = 'desktop';
    }
  },

  init: function() {
    const _this = this;
    if (_this.el.accordions.length === 0 || _this.el.tabs.length === 0) return;

    _this.el.accordions.forEach(accordion => {
      const summary = accordion.querySelector('summary');
      const tab = [..._this.el.tabs].filter(tab => tab.hash == `#${accordion.id}`)[0];
      summary.addEventListener('click', e => {
        e.preventDefault();
        _this.el.accordions.forEach(acc => acc !== accordion && acc.removeAttribute('open'));
        _this.el.tabs.forEach(t => t !== tab && t.classList.remove('active'));
        tab.classList.toggle('active');
        accordion.toggleAttribute('open');
        accordion.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
    _this.el.tabs.forEach(tab => {
      const accordion = document.querySelector(tab.hash);
      tab.addEventListener('click', e => {
        e.preventDefault();
        _this.el.tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        _this.el.accordions.forEach(acc => acc.removeAttribute('open'));
        accordion.setAttribute('open','');
      });
    });

    _this.updateActiveTab();
    window.addEventListener('resize', _this.updateActiveTab);
  }
}
window.app.productTabs.init();